import { LeasingCalculatorSharedFormProps } from 'modules/leasingCalculator/components/common/LeasingCalculatorData';
import { LeasingType } from 'modules/types/LeasingOffer';
import { Button } from 'modules/ui';
import { useForm } from 'modules/ui/form/useForm';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { UwtType } from 'modules/types/LeasingCalculatorCodes';
import { FooterButtonsContainer } from './styled';
import { LeasingCalculatorPathsEnum } from '../../../../../routes';

interface FooterButtonsProps extends LeasingCalculatorSharedFormProps {
  findLeasingTypeByName: (leasingTypeName: string) => UwtType | undefined;
  type: LeasingType;
}

export const FooterButtons: React.FC<FooterButtonsProps> = ({
  defaultValues,
  onChange,
  findLeasingTypeByName,
  type,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { updateFormData } = useForm({
    onChange,
  });

  const isDisabled =
    !defaultValues?.leasingNetObjectPrice ||
    +defaultValues.leasingNetObjectPrice === 0 ||
    !defaultValues?.financingPeriod ||
    !defaultValues?.leasingPaymentPeriodType;

  const updateLeasingTypeAndRedirect = (leasingTypeName?: string) => {
    if (leasingTypeName) {
      const leasingType = findLeasingTypeByName(leasingTypeName);
      leasingType && updateFormData('leasingType', leasingType);
    } else {
      delete defaultValues?.leasingType;
    }

    history.push(`${LeasingCalculatorPathsEnum.leasingCalculator}/offer`);
    // FOR ADVANCED CALCULATOR - HERE FOR POSSIBLE FUTURE REVERT
    // history.push(getLeasingCalculatorPageUrl(1));
  };

  return (
    <FooterButtonsContainer>
      {type === LeasingType.FINANCIAL && (
        <Button
          text={t(
            'leasingCalculator.infoCalculation.financialLeasingButtonText',
          )}
          disabled={isDisabled}
          onClick={() => updateLeasingTypeAndRedirect(LeasingType.FINANCIAL)}
        />
      )}
      {type === LeasingType.OPERATIONAL && (
        <Button
          text={t(
            'leasingCalculator.infoCalculation.operationalLeasingButtonText',
          )}
          disabled={isDisabled}
          onClick={() => updateLeasingTypeAndRedirect(LeasingType.OPERATIONAL)}
        />
      )}
    </FooterButtonsContainer>
  );
};
